/* eslint-disable react/no-unused-prop-types */
import React from "react";
import ErrorBoundaryFallback from "./Fallback";
import { ErrorBoundary } from "react-error-boundary";

interface P {
  children: React.ReactNode;
  onError: (error: unknown) => {
    title: string;
    subtitle: string | null;
    cta: string;
    onCTAClick: (() => void) | null;
  };
}

function ErrorBoundaryUI({ children, onError }: P) {
  const Fallback = React.useCallback(
    ({ error, resetErrorBoundary }: { error: unknown; resetErrorBoundary: () => void }) => (
      <ErrorBoundaryFallback
        resetErrorBoundary={resetErrorBoundary}
        onError={onError}
        error={error}
      />
    ),
    [onError],
  );

  return <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>;
}

export default ErrorBoundaryUI;
